import G6 from '@antv/g6'
import { statusColorDict } from './Legend'
G6.registerNode(
  'dom-rect',
  {
    draw: (cfg, group) => {
      return group.addShape('dom', {
        attrs: {
          width: cfg.size[0],
          height: cfg.size[1],
          // 传入 DOM 的 html
          html: `
        <div style="background-color: ${statusColorDict[cfg.statusDesc]}; border: 2px ${
            statusColorDict[cfg.statusDesc]
          } solid}; padding: 4px 0; border-radius: 4px; text-align: center; color: #fff;">
          <img draggable="false" src=${cfg.image} style="width: 20px; height: 20px; object-fit: contain;"></img>
          <div style="text-align: center; font-size: 15px;">${cfg.labelName || ''}</div>
        </div>
          `,
        },
        draggable: true,
      })
    },
    getAnchorPoints() {
      return [
        [0, 0.5],
        [1, 0.5],
        [0.5, 0],
        [0.5, 1],
      ]
    },
  },
  'single-node'
)

G6.registerNode(
  'dom-lane',
  {
    draw: (cfg, group) => {
      let children = (cfg.lane.camera || [])
        .map(e => {
          return `<div style="font-size:14px;	background-color: ${
            statusColorDict[e.statusDesc]
          }; text-align: center; padding: 4px;border-radius: 2px;"><img draggable="false" src="${
            e.image
          }" style="width: 20px; height: 20px; object-fit: contain;"></img><div>${e.labelName}</div></div>`
        })
        .join('')
      return group.addShape('dom', {
        attrs: {
          width: cfg.size[0],
          height: cfg.size[1],
          // 传入 DOM 的 html
          html: `
        <div style="color: #fff; background-color: #163f46; border: 2px solid #163f46; border-radius: 4px; width: ${cfg.size[0]}px; height: ${cfg.size[1]}px;">
          <div style="text-align: center; font-size: 15px;margin-bottom: 4px;">${cfg.lane.name || ''}</div>
          <div style="display: flex; align-items: center; 
      justify-content: space-around;">${children}</div>
        </div>
          `,
        },
        draggable: true,
      })
    },
    getAnchorPoints() {
      return [
        [0, 0.5],
        [1, 0.5],
        [0.5, 0],
        [0.5, 1],
      ]
    },
  },
  'single-node'
)

export default G6
